export default __webpack_public_path__ + "static/media/blue.82399d0c.png";